import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_2 = { class: "tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]" }
const _hoisted_3 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "tw-font-semibold"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[3px] tw-h-[3px] tw-bg-[#231F20] tw-rounded-[100%] tw-m-[9.3px]" }, null, -1)
const _hoisted_9 = { class: "tw-flex-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["disabled"]

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText, isContainHTML } from "@/utils/utilities";
import { computed, onMounted, PropType, Ref, ref, watch } from "vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import ButtonLoading from "../common/buttonLoading.vue";
import store from "@/store";
import { ARE_YOU_SURE_TYPES } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'areYouSureModal',
  props: {
  headerTitle: {
    type: String,
    required: false,
    default: "",
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  list: {
    type: Array as () => Array<string>,
    required: false,
    default: () => [],
  },
  buttonText: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  buttonRed: {
    type: Boolean,
    required: false,
    default: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  slotCustom: {
    type: Object,
    required: false,
    default: null,
  },
  disableButtonRed: {
    type: Boolean,
    required: false,
    default: false,
  },
  hiddenHelp: {
    type: Boolean,
    required: false,
    default: true,
  },
  submitButton: {
    type: [String, Boolean],
    required: false,
    default: false,
  },
  titleShowBtnSubmit2: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  questionContain: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  additionalNote: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  blueText: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  isShowBtnCancel: {
    type: Boolean,
    required: false,
    default: true,
  },
  isValidate: {
    type: Boolean,
    required: false,
    default: false,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 38,
  },
  styleClass: {
    type: Object,
    required: false,
    default: () => ({
      background: "rgba(0, 0, 0, 0.5)",
      "z-index": "1072",
    }),
  },
  modalContainerClass: {
    type: String,
    default: "",
  },
  updateDataFunction: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
  updateDataFunction2: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
  type: {
    type: String,
    required: false,
    default: "",
  },
  disableCloseModal: {
    type: Object as PropType<Ref<boolean>>,
    required: false,
    default: ref(false),
  },
  styleClassContain: {
    type: Object,
    required: false,
    default: () => ({
      "border-radius": "4px",
      "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
      "z-index": "2222",
    }),
  },
},
  emits: [
  "update:show",
  "update:data",
  "update:data2",
  "update:close",
  "update:dataSubmit2",
],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
let animationWidth = ref(0);
const innerTextRedBtnRef: Ref = ref(null);
const isLoadingUpdateData = ref(false);
const loadingButtonRed = computed(
  () => store.state.LoadingAreYouSureButtonModal.loadingRedButton,
);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const numberButton = () => {
  let number = 1;
  if (props.titleShowBtnSubmit2) {
    number += 1;
  }
  if (props.isShowBtnCancel) {
    number += 1;
  }
  if (props.buttonRed && props.submitButton) {
    number += 1;
  }
  return number;
};


const handleCloseModal = (isCancel = false, isClickIconClose = false) => {
  if (props.disableCloseModal.value && !isClickIconClose) return;

  store.commit("User/setIsCloseModalProfile", true);
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:close", isCancel);
};
const handleUpdateModal = async () => {
  isLoadingUpdateData.value = true;
  if (props.updateDataFunction) {
    const data: any = await props.updateDataFunction(false);
    if (data || data === undefined) {
      showRef.value = false;
    } else {
      isLoadingUpdateData.value = false;
      showRef.value = true;
      return;
    }
  } else {
    emit("update:data", false);
    if (innerTextRedBtnRef.value && loadingButtonRed) {
      animationWidth.value = innerTextRedBtnRef.value.getBoundingClientRect()[
        "width"
      ] as number;
    }
  }

  if (props.isValidate) {
    isLoadingUpdateData.value = false;
    return;
  }
  if (
    ![
      ARE_YOU_SURE_TYPES.settingDomainMultiDelete,
      ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
    ].includes(props.type)
  ) {
    showRef.value = false;
    emit("update:show", showRef.value);
    store.commit("User/setIsCloseModalProfile", true);
  }
  isLoadingUpdateData.value = false;
};
const handleUpdateModal2 = async () => {
  showRef.value = false;

  if (props.updateDataFunction2) await props.updateDataFunction2(false);
  else emit("update:data2", showRef.value);

  store.commit("User/setIsCloseModalProfile", true);
};
const handleUpdateBtnSubmit2 = () => {
  emit("update:dataSubmit2", showRef.value);
  handleCloseModal();
};

watch(
  () => loadingButtonRed.value,
  (newValue, oldValue) => {
    if (!newValue && oldValue) {
      if (
        [
          ARE_YOU_SURE_TYPES.settingDomainMultiDelete,
          ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
        ].includes(props.type)
      ) {
        showRef.value = false;
        emit("update:show", showRef.value);
        store.commit("User/setIsCloseModalProfile", true);
      }
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": __props.maxWidth,
    "style-class": __props.styleClass,
    "style-class-contain": __props.styleClassContain,
    "class-name": __props.modalContainerClass
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"z-index":"10"},
        "is-header": __props.headerTitle ? `` : `no__header`,
        class: _normalizeClass('tw-px-[20px] sm:tw-px-[40px]'),
        title: __props.headerTitle,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (handleCloseModal(false, true)))
      }, null, 8, ["is-header", "title"]),
      _createElementVNode("div", {
        class: _normalizeClass([
        'tw-pt-0 tw-p-[39px] tw-flex tw-flex-col',
        __props.headerTitle ? 'tw-pt-[39px]' : '',
      ])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_unref(isContainHTML)(__props.description))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: __props.description
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.description), 1)),
            (__props.hiddenHelp)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.additionalNote
                ? __props.additionalNote
                : _unref(getComponentUiText)(
                    "app-settings-team-members-profile-modal-delete-action-helper-b-1",
                  )), 1))
              : _createCommentVNode("", true)
          ]),
          (__props.list?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "tw-flex"
                  }, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default"),
          (!!__props.slotCustom)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.slotCustom), { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex tw-mt-10 sm:tw-flex-row tw-justify-end tw-gap-[15px] sm:tw-gap-[0px] ${
          numberButton() > 2 ? 'tw-flex-col' : ''
        }`)
        }, [
          (__props.isShowBtnCancel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_b_button, {
                  "data-cy": "are-you-sure-modal-cancel-button",
                  style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
                  variant: "primary",
                  class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                  type: "submit",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCloseModal(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.blueText
                ? __props.blueText
                : _unref(getComponentUiText)(
                    "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
                  )), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(
            __props.titleShowBtnSubmit2 ? `tw-flex tw-flex-wrap tw-gap-[15px]` : ''
          )
          }, [
            (__props.buttonRed)
              ? (_openBlock(), _createBlock(ButtonLoading, {
                  key: 0,
                  title: 
              __props.buttonText ??
              _unref(getComponentUiText)(
                'app-settings-domain-verify-modal-delete-button-1',
              )
            ,
                  class: _normalizeClass(`tw-border-[#F7553C] tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium ${
              __props.disableButtonRed ? '!tw-text-[#B7B7B7]' : ' tw-text-white '
            } !tw-opacity-100`),
                  disabled: __props.disableButtonRed,
                  "is-loading": isLoadingUpdateData.value || loadingButtonRed.value,
                  onClickAction: handleUpdateModal
                }, null, 8, ["title", "class", "disabled", "is-loading"]))
              : _createCommentVNode("", true),
            (__props.buttonRed && __props.submitButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  "data-cy": "are-you-sure-modal-reset-passkey-button",
                  disabled: __props.disableButtonRed,
                  class: _normalizeClass(["tw-border-[#F7553C] tw-ml-[15px] tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium", [
              __props.disableButtonRed ? 'tw-text-[#B7B7B7]' : ' tw-text-white ',
            ]]),
                  onClick: handleUpdateModal2
                }, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-team-members-reset-passkey-button-1",
              )), 11, _hoisted_11))
              : _createCommentVNode("", true),
            (__props.titleShowBtnSubmit2)
              ? (_openBlock(), _createBlock(_component_b_button, {
                  key: 2,
                  style: {"line-height":"90%","height":"39px"},
                  variant: "primary",
                  class: _normalizeClass(`tw-w-fit tw-shadow-none ${`tw-bg-[#387DFF]`} tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
                  type: "submit",
                  "data-cy": "are-you-sure-modal-delete-modal-button-1",
                  onClick: handleUpdateBtnSubmit2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.titleShowBtnSubmit2 ??
              _unref(getComponentUiText)(
                "app-settings-domain-verify-modal-delete-button-1",
              )), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!__props.buttonRed)
              ? (_openBlock(), _createBlock(ButtonLoading, {
                  key: 3,
                  title: 
              __props.buttonText ??
              _unref(getComponentUiText)(
                'app-settings-domain-verify-modal-delete-button-1',
              )
            ,
                  "is-loading": isLoadingUpdateData.value,
                  onClickAction: handleUpdateModal
                }, null, 8, ["title", "is-loading"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2)
      ], 2)
    ]),
    _: 3
  }, 8, ["model-value", "max-width", "style-class", "style-class-contain", "class-name"]))
}
}

})